import React from "react";
import { Box, HStack, Stack, Text, Tooltip } from "@chakra-ui/react";
import { DashboardTextarea } from "components/utils/FormControls";
import { MdComment, MdRecordVoiceOver, MdRocketLaunch } from "react-icons/md";
import { FaStar } from "react-icons/fa";
import { DataCard } from "components/utils/DataCard";
import { FormDialog } from "components/utils/FormDialog";
import { toNullIfEmpty } from "utils/formatters";
import { useDialogForm } from "utils/useDialogForm";
import { emojiForRating, labelForRating, EmojiRatingBar } from "../components/EmojiRatingBar";

export const PosteriorEvaluacionCard = ({ actividad, actividadId, patch }) => {
  const dialog = useDialogForm({ calAct: "", calCharla: "", comentarios: "" });
  const saving = patch.isPending;
  const patchError = patch.isError ? String(patch.error?.message || patch.error) : null;
  const calActEmoji = emojiForRating(actividad?.calificacionActividad);
  const calCharlaEmoji = emojiForRating(actividad?.calificacionCharla);
  const calActLabel = labelForRating(actividad?.calificacionActividad);
  const calCharlaLabel = labelForRating(actividad?.calificacionCharla);
  const comentariosTxt = actividad?.comentarios?.trim() || "\u2014";

  function openDialog() {
    dialog.openWith({
      calAct: actividad?.calificacionActividad ? String(actividad.calificacionActividad) : "",
      calCharla: actividad?.calificacionCharla ? String(actividad.calificacionCharla) : "",
      comentarios: actividad?.comentarios ?? "",
    });
  }

  async function save() {
    await patch.mutateAsync({
      actividadId,
      patch: {
        calificacionActividad: dialog.form.calAct ? Number(dialog.form.calAct) : null,
        calificacionCharla: dialog.form.calCharla ? Number(dialog.form.calCharla) : null,
        comentarios: toNullIfEmpty(dialog.form.comentarios),
      },
    });
    dialog.close();
  }

  return (
    <>
      <DataCard title="Evaluacion" variant="yellow" headerIcon={<FaStar size="24px" />} onEdit={openDialog} editAriaLabel="Editar evaluacion">
        <Stack gap="4" alignItems="start">
          <HStack gap="6" align="start">
            <HStack gap="2.5" align="start">
              <Box color="dashboard.fg.muted" mt="0.5" flexShrink={0}><MdRocketLaunch size="16px" /></Box>
              <Stack gap="1">
                <Text fontSize="xs" color="dashboard.fg.muted" textTransform="uppercase" fontWeight="700" letterSpacing="0.06em">Actividad</Text>
                <Tooltip.Root openDelay={0}>
                  <Tooltip.Trigger asChild>
                    <Text fontSize="xl" lineHeight="1" cursor="default">{calActEmoji}</Text>
                  </Tooltip.Trigger>
                  <Tooltip.Positioner>
                    <Tooltip.Content>{calActLabel}</Tooltip.Content>
                  </Tooltip.Positioner>
                </Tooltip.Root>
              </Stack>
            </HStack>

            <HStack gap="2.5" align="start">
              <Box color="dashboard.fg.muted" mt="0.5" flexShrink={0}><MdRecordVoiceOver size="16px" /></Box>
              <Stack gap="1">
                <Text fontSize="xs" color="dashboard.fg.muted" textTransform="uppercase" fontWeight="700" letterSpacing="0.06em">Charla</Text>
                <Tooltip.Root openDelay={0}>
                  <Tooltip.Trigger asChild>
                    <Text fontSize="xl" lineHeight="1" cursor="default">{calCharlaEmoji}</Text>
                  </Tooltip.Trigger>
                  <Tooltip.Positioner>
                    <Tooltip.Content>{calCharlaLabel}</Tooltip.Content>
                  </Tooltip.Positioner>
                </Tooltip.Root>
              </Stack>
            </HStack>
          </HStack>

          <HStack gap="2.5" align="start">
            <Box color="dashboard.fg.muted" mt="0.5" flexShrink={0}><MdComment size="16px" /></Box>
            <Stack gap="0">
              <Text fontSize="xs" color="dashboard.fg.muted" textTransform="uppercase" fontWeight="700" letterSpacing="0.06em">Comentarios</Text>
              <Text fontSize="sm" color="dashboard.fg.muted">{comentariosTxt}</Text>
            </Stack>
          </HStack>
        </Stack>
      </DataCard>

      <FormDialog open={dialog.open} onOpenChange={dialog.onOpenChange} title="Editar Evaluacion" errorText={patchError} saving={saving} onCancel={dialog.close} onSave={save}>
        <Box>
          <Text fontSize="sm" fontWeight="600" color="dashboard.fg.default" mb="1">Calificacion Actividad</Text>
          <EmojiRatingBar value={Number(dialog.form.calAct) || null} onChange={(v) => dialog.setField("calAct", String(v))} isDisabled={saving} ariaLabel="Calificacion Actividad" />
        </Box>

        <Box>
          <Text fontSize="sm" fontWeight="600" color="dashboard.fg.default" mb="1">Calificacion Charla</Text>
          <EmojiRatingBar value={Number(dialog.form.calCharla) || null} onChange={(v) => dialog.setField("calCharla", String(v))} isDisabled={saving} ariaLabel="Calificacion Charla" />
        </Box>

        <Box>
          <Text fontSize="sm" fontWeight="600" color="dashboard.fg.default" mb="1">Comentarios</Text>
          <DashboardTextarea value={dialog.form.comentarios} onChange={(e) => dialog.setField("comentarios", e.target.value)} rows={5} placeholder="Que salio bien? Que mejorar?" />
          <Text color="dashboard.fg.muted" fontSize="sm" mt="1">Deja vacio para quitar comentarios.</Text>
        </Box>
      </FormDialog>
    </>
  );
};
